<template>
  <div class="columns is-vcentered">
    <div id="submit-container" class="column is-2">
      <button
        id="submitForm"
        type="submit"
        class="button is-success"
        @click.stop.prevent="submit"
      >
        Submit
      </button>
    </div>
    <div id="not-enough-submissions" class="column is-10 is-hidden">
      <div class="notification is-danger">
        You must fill out at least {{ voteRequirement }} names to submit this form.
      </div>
    </div>
  </div>
</template>

<script>
import bugsnagClient from '@/bugsnag';

export default {
  computed: {
    voteRequirement() {
      return this.$store.state.vote_requirement;
    },
  },
  methods: {
    submit() {
      /* Default validity check */
      if (!document.getElementById('survey').reportValidity()) {
        return false;
      }

      /* Manual required check */
      if (this.$store.state.manual_required_check) {
        /* This needs to remain a for loop as we must return false if validation fails */
        // eslint-disable-next-line no-restricted-syntax
        for (const field of Object.keys(this.$store.state.manual_required_check)) {
          if (!this.$store.state.manual_required_check[field]) {
            const fieldNode = document.getElementById(`${field}-field`);
            document.getElementById(`${field}-container`).scrollIntoView();
            fieldNode.classList.add('is-tooltip-active');
            setTimeout(() => { fieldNode.classList.remove('is-tooltip-active'); }, 2000);

            return false;
          }
        }
      }

      /* Vote count check */
      if (this.$store.state.vote_count < this.voteRequirement) {
        document.getElementById('not-enough-submissions').classList.remove('is-hidden');
        setTimeout(() => {
          document.getElementById('not-enough-submissions').classList.add('is-hidden');
        }, 5000);
        return false;
      }

      // If no errors, reset the progress bar and submit the reuslts.
      this.$store.dispatch('resetVoteCount');

      const query = this.http_build_query({
        sheet: this.$store.state.google_sheet_title,
        project_id: this.$store.state.project_id,
        uuid: this.$store.state.uuid,
      });

      window.fetch(`//dj5-api.datajoe.com/api/survey?${query}`, {
        body: this.$store.state.submission,
        method: 'post',
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }).then((res) => {
        if (!res.ok) {
          this.submissionReport();
          bugsnagClient.notify(res.statusText);
        }
      }).catch((error) => {
        this.submissionReport();
        bugsnagClient.notify(error);
      });

      return this.$router.push('thankyou');
    },
    http_build_query(jsonObj) {
      const keys = Object.keys(jsonObj);
      const values = keys.map(key => jsonObj[key]);

      return keys
        .map((key, index) => `${key}=${values[index]}`)
        .join('&');
    },
    submissionReport() {
      let submissionData = '';
      // Caleb, I am disabling eslint for this, it's not quite clear to me why we are restricting
      // the use of for-of, lets discuss

      // eslint-disable-next-line no-restricted-syntax
      for (const pair of this.$store.state.submission.entries()) {
        submissionData = `${submissionData + pair[0]}: ${pair[1]}, `;
      }
      console.log(submissionData);
      bugsnagClient.metaData = { submission: submissionData };
    },
  },
};
</script>
